import React from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { Button } from "@/components/ui/button";

export const PAGE_SIZE = 10;

export function paginate(items, page) {
  const pageCount = Math.max(1, Math.ceil(items.length / PAGE_SIZE));
  const current = Math.min(page, pageCount);
  return { pageCount, current, visible: items.slice((current - 1) * PAGE_SIZE, current * PAGE_SIZE) };
}

export function Pager({ page, pageCount, total, onChange, testid = "pager" }) {
  if (pageCount <= 1) return null;
  const from = (page - 1) * PAGE_SIZE + 1;
  const to = Math.min(page * PAGE_SIZE, total);
  const btn = "border-slate-700 bg-slate-900/60 text-slate-200 hover:bg-slate-800";
  return (
    <div className="flex items-center justify-between gap-3 pt-2" data-testid={testid}>
      <span className="text-sm text-slate-400" data-testid={`${testid}-info`}>Showing {from}–{to} of {total}</span>
      <div className="flex items-center gap-1.5">
        <Button variant="outline" size="sm" disabled={page <= 1} onClick={() => onChange(page - 1)} data-testid={`${testid}-prev`} className={btn}>
          <ChevronLeft className="w-4 h-4" /> Prev
        </Button>
        <span className="font-mono-num text-sm text-slate-300 px-2">{page} / {pageCount}</span>
        <Button variant="outline" size="sm" disabled={page >= pageCount} onClick={() => onChange(page + 1)} data-testid={`${testid}-next`} className={btn}>
          Next <ChevronRight className="w-4 h-4" />
        </Button>
      </div>
    </div>
  );
}
